var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-text-field',{class:_vm.classes['switch'],style:(_vm.localStyle['switch']),attrs:{"color":_vm.color,"label":_vm.labelFilter,"append-icon":_vm.postIcon,"prepend-icon":_vm.preIcon,"filled":""},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }